import React, {useEffect, useState} from 'react'
import styles from '../css/PerTargetLimits.module.css'
import TargetLimitBox from './TargetLimitBox'
import Toggle from '../../../globalcomponents/Toggle'
import targetingDefaultPerTargetLimits from '../../../lookup/admin/targeting/targetingDefaultPerTargetLimits.json'

function PerTargetLimits(props) {
    const [wiggle, setWiggle] = useState(false)
    const [valid, setValid] = useState(true)
    const [perTargetLimits, setPerTargetLimits] = useState(targetingDefaultPerTargetLimits.team[props.team].defaultTargetOptions)
    const [allowDIR, setAllowDIR] = useState(targetingDefaultPerTargetLimits.team[props.team]?.allowDIR ?? false)
    const [allowMOT, setAllowMOT] = useState(targetingDefaultPerTargetLimits.team[props.team]?.allowMOT ?? false)
    const [excludeNTAddsFromCap, setExcludeNTAddsFromCap] = useState(targetingDefaultPerTargetLimits.team[props.team]?.excludeNTAddsFromCap ?? false)

    let totalMaxChanges = 0;
    let totalMinRequired = 0;

    let targetLimitBoxes = []
        for (let i = 0; i < Object.keys(perTargetLimits).length; i++) {

        const key = Object.keys(perTargetLimits)[i]

        totalMaxChanges += parseInt(perTargetLimits[key]?.maxChanges);
        totalMinRequired += parseInt(perTargetLimits[key]?.minRequired);

        targetLimitBoxes.push(<TargetLimitBox key={i} data={perTargetLimits} setData={setPerTargetLimits} dataKey={key} valid={valid} limitType={props.exercise?.limitType ?? 'percent'}/>) 
    }

    let overMaxCalls = false;
    let overMinCalls = false;

    let disableNextButton = false;

    // Advisory: territory has a call cap but no per-target call limits are configured
    const allPerTargetCallsUnlimited = Object.keys(perTargetLimits).every(
        key => parseInt(perTargetLimits[key]?.maxCalls) === 0
    );
    const showCallAdvisory = allPerTargetCallsUnlimited && parseInt(props.exercise?.maxCallsPerTerritory) > 0;

    // Advisory: territory has a churn cap but no per-target outflow limits are configured
    const allPerTargetUnlimited = Object.keys(perTargetLimits).every(
        key => parseInt(perTargetLimits[key]?.maxChanges) === 0
    );
    const showUnlimitedAdvisory = allPerTargetUnlimited && parseInt(props.exercise?.maxChangesPerTerritory) > 0;

    let directionsText = (
        <div className={styles.directions}>
            The default target config for this team/exercise are listed below and toggled on. Use "0" for unlimited.
        </div>
    )

    const limitSymbol = (props.exercise?.limitType ?? 'percent') === 'static' ? '#' : '%';
    const advisories = [
        showUnlimitedAdvisory && `⚠️ No per-target reclassification limits set — the ${props.exercise?.maxChangesPerTerritory}${limitSymbol} territory cap will be the only guardrail.`,
        showCallAdvisory && `⚠️ No per-target call limits set — the ${props.exercise?.maxCallsPerTerritory}${limitSymbol} territory call cap will be the only guardrail.`,
    ].filter(Boolean);

    return (
        <div className={styles.editScreen}>
            <div className={styles.title}>
                <div></div>
                <div className={styles.titleText}>Add Exercise - Per Target Limits</div>
                <div className={styles.close} onClick={() => {
                    props.close()
                }}><i className="fas fa-times"></i></div>
            </div>
            <form>
                <div className={styles.body}>
                    <div className={styles.titleRow}>
                        {directionsText}
                    </div>
                    {advisories.length > 0 && (
                        <div className={styles.advisoryRow}>
                            {advisories.map((a, i) => (
                                <div key={i} className={styles.directionsError}>{a}</div>
                            ))}
                        </div>
                    )}
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: 6, margin: '4px 0 12px', overflow: 'hidden' }}>
                        {[
                            { active: allowDIR,             set: setAllowDIR,             accent: '#ce93d8', color: '#6a1b9a', label: 'Allow DIR (Deceased / Inactive / Retired) — reps can mark HCPs as DIR without counting against change limits' },
                            { active: allowMOT,             set: setAllowMOT,             accent: '#90caf9', color: '#1565c0', label: 'Allow MOT (Moved Out of Territory) — reps can flag HCPs as moved without counting against change limits or changing the target type' },
                            { active: excludeNTAddsFromCap, set: setExcludeNTAddsFromCap, accent: '#ffcc80', color: '#e65100', label: 'Exclude NT upgrades from reclassification cap — NT→A/B/C adds do not count against the territory change limit' },
                        ].map((row, i, arr) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 12px', borderBottom: i < arr.length - 1 ? '1px solid #f0f0f0' : 'none', borderLeft: `4px solid ${row.accent}` }}>
                                <div style={{ flexShrink: 0, width: 44 }}><Toggle active={row.active} click={() => row.set(v => !v)} /></div>
                                <span style={{ flex: 1, fontSize: 11.5, fontWeight: 500, color: row.color, lineHeight: 1.35 }}>{row.label}</span>
                            </div>
                        ))}
                    </div>
                    <div className={styles.content}>

                        {targetLimitBoxes}
                        
                    </div>
                    <div className={styles.buttonRow}>
                        <div id={styles.cancel}
                            onClick={() => {
                                props.setExercise({
                                        ...props.exercise
                                    })
                                props.setView(props.view - 1)
                            }
                        }>BACK</div>
                        <div type="submit" id={styles.submit} className={wiggle ? styles.Wiggle : ""} onClick={() => {
                                if (perTargetLimits !== "" && !disableNextButton) {
                                    props.setExercise({
                                        ...props.exercise,
                                        perTargetLimits: JSON.stringify({ ...perTargetLimits, allowDIR, allowMOT, excludeNTAddsFromCap })
                                    })
                                    props.setView(props.view + 1)
                                }
                                else {
                                    setWiggle(true)
                                    setValid(false)
                                    setTimeout(() => {
                                        setWiggle(false)
                                    }, 500);
                                }
                            }
                        }>NEXT</div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default PerTargetLimits
